import React, { useMemo } from 'react'
import {Avatar, Dropdown, Typography, Menu, Button} from 'antd'   
import {Link} from 'react-router-dom'
import { useDispatch } from 'react-redux'
import {doLogout} from '../../redux'
import { UserOutlined } from '@ant-design/icons'
import Language from './languages';
export const UserProfile=({username, level, isColapsed, noMargin, noGrow})=>{
    const dispatch=useDispatch();
    
    const OverlayMenu=()=>{
        return <Menu items={[
            {
                label:<Link to={'/profile'}>Profile</Link>,
                key:'Profile'
            },
            {
                label:<Link to={'/login'} onClick={()=>dispatch(doLogout())} >Logout</Link>,
                key:'Logout'
            },
        ]}/>
    }
    
    const margin=useMemo(()=>{
        if(noMargin===true)return {};
        return {marginRight:isColapsed?128:248};
    }, [noMargin, isColapsed])

    return (
        <div className='user-profile-wrapper' style={{...margin, flexGrow:noGrow?'unset':1}}>
            <div className='user-profile-text-wrapper'>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end', gap:8, height:24, alignItems:'center'}}>
                    <Typography.Text strong type='success' className='user-profile-text'>
                        {username}
                    </Typography.Text>
                    <Language />
                </div>
                <Typography.Text ellipsis type='success' className='user-profile-text user-profile-status'>
                    {level}
                </Typography.Text>
            </div>
            <Dropdown placement='bottomLeft' menu={OverlayMenu} trigger={['click']}>
                <Avatar size={'large'} icon={<UserOutlined />} />
            </Dropdown>
        </div>
    )
}